





















import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';
import { Student } from '@/models/student/student';
import { GPageBase } from '@/mixins';
import { schoolClassChangeModule } from '@/store/modules/frames/school-class-change.module';
import { GEnum } from '@/constants/enum.defination';

@Component({
  name: 'GSchoolClassChangeStudentTile',
  computed: {},
  methods: {},
})
export default class GSchoolClassChangeStudentTile extends Mixins(GPageBase) {
  @Prop() student: Student;
  @Prop({ default: GEnum.DragAreaType.TypeSchoolClass }) dragAreaType: GEnum.DragAreaType;
  mounted() {}

  get isDragAreaTypeWorkSpace(): boolean {
    return this.dragAreaType === GEnum.DragAreaType.TypeWorkSpace;
  }

  get studentShowMode(): boolean {
    return schoolClassChangeModule.studentShowMode;
  }

  handleClickCheck() {
    this.student.checked = !this.student.checked;
  }
}
